"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ComprehensionEvaluator = void 0;
class ComprehensionEvaluator {
    async evaluate(submission, activity) {
        const prompt = String(activity.config.prompt ?? '');
        const studentText = String(submission.finalText ?? '').trim();
        // Comprehension is open-ended; we can't auto-grade content without a rubric.
        // Placeholder: give partial credit for writing length, full marks for any non-empty response.
        // Teacher review is expected to override.
        const score = studentText.length > 0 ? 70 : 0;
        const isCorrect = studentText.length > 0;
        return {
            score,
            maxScore: 100,
            isCorrect,
            feedback: studentText.length > 0
                ? 'Thank you for your response. Your teacher will review it soon.'
                : 'Please write your answer before submitting.',
            breakdown: [
                { name: 'Response Present', score: isCorrect ? 70 : 0, maxScore: 70, feedback: isCorrect ? 'Answer submitted' : 'No answer' },
                { name: 'Teacher Review', score: 0, maxScore: 30, feedback: 'Pending teacher assessment' },
            ],
            skills: [{ key: `comprehension:${prompt.slice(0, 30).toLowerCase()}`, label: 'Reading Comprehension' }],
            label: 'Comprehension Score',
        };
    }
}
exports.ComprehensionEvaluator = ComprehensionEvaluator;
